import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';

import logo_img from 'raw!svgo?useConfig=svgoConfig!./logo._svg';

class Logo extends PureComponent {
  static propTypes = {
    color: PropTypes.string.isRequired
  };

  render() {
    require('./Logo.styl');
    const { color, ...props } = this.props;
    return (
      <div
        className="Logo"
        style={{ color }}
        dangerouslySetInnerHTML={{ __html: logo_img }}
        {...props}
      />
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js